import { Slot } from '@radix-ui/react-slot'
import { LoaderCircle } from 'lucide-react'

import { buttonVariants } from '#components/ui/button-styles.js'
import { cn } from '#components/utils.js'

export { buttonVariants }

export function Button({
  asChild = false,
  children,
  className,
  disabled,
  loading = false,
  size,
  variant,
  ...props
}) {
  const Component = asChild ? Slot : 'button'

  return (
    <Component
      aria-busy={loading || undefined}
      className={cn(buttonVariants({ size, variant }), className)}
      data-slot='button'
      disabled={asChild ? undefined : disabled || loading}
      {...props}
    >
      {asChild ? (
        children
      ) : (
        <>
          <span
            className={cn(
              'inline-flex items-center gap-2',
              loading && 'opacity-0',
            )}
          >
            {children}
          </span>
          {loading && (
            <LoaderCircle
              aria-hidden='true'
              className='absolute animate-spin motion-reduce:animate-none'
            />
          )}
        </>
      )}
    </Component>
  )
}
